import type {
  ContentPage,
  ContentPageSummary,
  DefaultResponseBody,
  ListResponseBody,
} from "@gerama/types";
import type { ApiClient } from "../client";

/** Public legal/about pages admins edit under `/admin/content-pages` (`GET /content-pages`, `/content-pages/:slug`). */
export function createCoreContentPagesApi(client: ApiClient) {
  return {
    list: (signal?: AbortSignal) =>
      client
        .request<ListResponseBody<ContentPageSummary>>("/content-pages", { signal })
        .then((res) => res.data?.list ?? []),

    detail: (slug: string, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<ContentPage>>(`/content-pages/${encodeURIComponent(slug)}`, {
          signal,
        })
        .then((res) => res.data as ContentPage),
  };
}
